import React, { useEffect, useReducer } from "react";
import { Button } from "semantic-ui-react";
import InfiniteScroll from "react-infinite-scroll-component";
import { ActionCable } from 'react-actioncable-provider';

import SemanticUiModal from "../../../../components/modal";
import useApiService from "../../../../services/useApiService";
import Api from "../../../../services/api";
import { getText } from "../../../../helpers";

import TranslationsTable from "./translation_modal_content/tanslations_table";
import TranslationsTableFilters from "./translation_modal_content/tanslations_table_filters";
import ElementLoader from "../../../../components/element_loader";

const modalOptions = { className: "full-height-modal", size: "fullscreen" };

const ITEMS_PER_PAGE = 15;

const initialTranslationState = {
  controls: [],
  page: 1,
};

function translationsReducer(state, action) {
  const updatedState = { ...state };

  switch (action.type) {
    case "NEW_DATA":
      updatedState.controls = updatedState.controls.concat(action.data);
      break;

    case "NEXT_PAGE":
      updatedState.page = updatedState.page + 1;
      break;

    case "RESET":
      updatedState.controls = [];
      updatedState.page = 1;
      break;

    case "NEW_TRANSLATION":
      const control = updatedState.controls.find(({ custom_id }) => custom_id === action.library_control.custom_id)
      if (control) {
        control.translations = action.library_control.translations;
      }
      break;

    default:
      break;
  }

  return updatedState;
}

async function createTranslation(library_control_id, languages) {
  const api = new Api()
  api.post("/__api/v1/library_control_translations", { library_control_id, languages })
}

export default function TranslationsModal(props) {
  const { filters, onClose, showTranslationModal, enabledLanguages } = props;
  const [{ page, controls }, dispatch] = useReducer(translationsReducer, initialTranslationState);
  const [{ isLoading, response }, fetchLibraryControls] = useApiService({ url: "/library_controls", onSuccess });

  function getUntranslatedLanguages (translations) {
    let untranslatedLanguages = [];
    for (const language of enabledLanguages) {
      if (language === "English") continue;
      if (!translations[language.toLowerCase()]) {
        untranslatedLanguages.push(language);
      }
    }
    return untranslatedLanguages
  }

  function onSuccess(data) {
    dispatch({ type: "NEW_DATA", data })

    data.forEach((control) => {
      const untranslatedLanguages = getUntranslatedLanguages(control.translations);
      const _hasUntranslatedLanguage = untranslatedLanguages && untranslatedLanguages.length !== 0;
      if (_hasUntranslatedLanguage) {
        createTranslation(control.id, untranslatedLanguages)
      }
    });
  }

  function getLibraryControls() {
    fetchLibraryControls({ params: { ...filters, page, include_translation: true } });
  }

  useEffect(() => {
    getLibraryControls();
  }, [page]);

  function nexPage() {
    dispatch({ type: "NEXT_PAGE" });
  }

  function reloadControls() {
    dispatch({ type: "RESET" });

    if (page === 1) getLibraryControls();
  }

  function libraryControlChannelListener(event) {
    if (!event.library_control) return;

    if (event.type === "completed_translation") {
      dispatch({ type: "NEW_TRANSLATION", library_control: event.library_control })
    }
  }

  const hasMore = response && response.length === ITEMS_PER_PAGE;

  return (
    <SemanticUiModal
      modalOptions={modalOptions}
      header={getText("Translations")}
      content={
        <React.Fragment>
          <TranslationsTableFilters filters={filters} />
          <div className="translations-table">
            <ActionCable channel={{ channel: 'LibraryControlChannel' }} onReceived={libraryControlChannelListener} />
            <InfiniteScroll dataLength={controls.length} next={nexPage} hasMore={hasMore} height="auto">
              <TranslationsTable controls={controls} reloadControls={reloadControls} showTranslationModal={showTranslationModal} />
            </InfiniteScroll>
            <ElementLoader isLoading={isLoading} message={`${getText("Fetching translations")}...`} />
          </div>
        </React.Fragment>
      }
      closeModal={onClose}
      actions={<Button onClick={onClose}>{getText("Close")}</Button>}
    />
  );
}



// WEBPACK FOOTER //
// ./src/views/control_library/table/tanslations_modal/translations_modal.js